// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Field_wrapper__396Wp","label":"Field_label__3M3Tn","value":"Field_value__2Pxgb"};